import { render, staticRenderFns } from "./question-type.vue?vue&type=template&id=22efa80d&scoped=true&"
import script from "./question-type.vue?vue&type=script&lang=js&"
export * from "./question-type.vue?vue&type=script&lang=js&"
import style0 from "./question-type.vue?vue&type=style&index=0&id=22efa80d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22efa80d",
  null
  
)

export default component.exports